import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "qa/dDe",
    defaultMessage: "Playground",
    description: "GraphiQL Playground in the dev mode panel",
  },
});
